import {_, pluralize, classNames, React, observer, useLocalStore, useEffect} from '@api'
import {Button} from '@blueprintjs/core'
import {FieldRendererStore, useFieldRendererStore} from '@design-board/stores'
import {SidebarSpecification} from '@lazy'
import {computed} from 'mobx'
import * as css from './DropdownCardField.css'

/// region Store

export interface TextRemoteSpecValue {
  exId: string
  name: string

  __parent?: any
  __path?: string
}

class DropdownCardFieldStore {
  constructor(public store: FieldRendererStore) {

  }

  @computed get buttonText() {
    const {selectedValues} = this

    if (_.isEmpty(selectedValues)) return `Select ${pluralize(this.store.label)}...`
    else {
      return selectedValues.length > 0 && selectedValues?.map(v => v.name).join(', ')
    }
  }

  @computed get selectedValues(): Array<TextRemoteSpecValue> { return !this.store.value.val ? [] : _.isArray(this.store.value.val) ? this.store.value.val : [this.store.value.val]}

  registerEffects = () => {
    const toDispose = []

    return () => toDispose.forEach(d => d())
  }
}

export const DropdownCardField = observer<{ className?: string }>(function DropdownCardField({className}) {
  const store = useFieldRendererStore(),
    {currencyIcon, catalogField, value: {val: value}, togglePopover, setShowPopoverOnKeydown, readOnly, editor} = store,
    dropdownStore = useLocalStore(() => new DropdownCardFieldStore(store)),
    {buttonText, selectedValues} = dropdownStore

  useEffect(() => dropdownStore.registerEffects(), [])

  // console.log(toJS({value, catalogField, buttonText, selected, selectedValues}, {recurseEverything: true}))
  return (
    <div className={classNames(css.root, className)}
         data-selected={selectedValues?.length}
         data-disabled={readOnly}
         data-type='DropdownField'
    >
      <SidebarSpecification
        className={classNames(css.popover)}
        popoverPosition={'right'}
        field={catalogField}
        data={value}
        // onOpenPopover={onAddMenuOpen}
        // onClosePopover={onCloseMenuOpen}
        button={
          <Button id={catalogField?.field}
                  className={css.button}
                  disabled={readOnly}
                  onKeyDown={(e) => {setShowPopoverOnKeydown(e)}}
                  onClick={() => togglePopover()} minimal={editor?.minimal !== false}
                  rightIcon={readOnly ? undefined : 'caret-down'}
                  text={currencyIcon ? `${currencyIcon} ${buttonText}` : buttonText}
          />}
      />
    </div>)
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/DropdownCardField.tsx